export const fallbackAppId = "unknown"; // same as pitcher

export const appId = "codesandbox";

export const externalAppIds = [
  "vscode",
  "playjs",
  "sdk",
  "inline-preview",
] as const;

export const appIds = [fallbackAppId, appId, ...externalAppIds] as const;

export type AppId = (typeof appIds)[number];
